import { ChevronLeft, Download, Plus } from "lucide-react";
import React from "react";

const ContractModal = ({
  modalType,
  selectedTemplates,
  importView,
  setImportView,
  setModalOpen,
  setSelectedTemplates,
}) => {
  return (
    <>
      {" "}
      {modalType === "productList" ? (
        <div className="p-6 space-y-4">
          <h3 className="text-sm font-bold text-slate-700">
            AI Rephrase Templates
          </h3>
        </div>
      ) : (
        <div className="p-6">
          {!importView ? (
            /* STEP 1: INITIAL CHOICE OR EDITING */
            <div className="space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <button
                  onClick={() => {
                    /* Logic to clear current and start fresh */
                  }}
                  className="flex flex-col items-center justify-center p-8 border-2 border-dashed border-slate-200 rounded-2xl hover:border-blue-400 hover:bg-blue-50 transition-all group"
                >
                  <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mb-3 group-hover:bg-blue-100">
                    <Plus className="text-slate-500 group-hover:text-blue-600" />
                  </div>
                  <span className="text-sm font-bold text-slate-700">
                    Create Default
                  </span>
                  <span className="text-[10px] text-slate-400 mt-1 text-center">
                    Start with a blank structure
                  </span>
                </button>

                <button
                  onClick={() => setImportView(true)}
                  className="flex flex-col items-center justify-center p-8 border-2 border-blue-100 bg-blue-50/30 rounded-2xl hover:border-blue-400 hover:bg-blue-50 transition-all group"
                >
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                    <Download className="text-blue-600" />
                  </div>
                  <span className="text-sm font-bold text-blue-700">
                    Import from List
                  </span>
                  <span className="text-[10px] text-blue-400 mt-1 text-center">
                    Use a saved business layout
                  </span>
                </button>
              </div>

              {/* Current Active Working Area */}
              <div className="mt-8">
                <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest mb-3 block">
                  Current {modalType} Editor
                </label>
                <textarea
                  className="w-full h-48 p-4 text-sm font-mono border rounded-xl focus:ring-2 focus:ring-blue-500 outline-none bg-slate-50 shadow-inner"
                  placeholder={`Enter ${modalType} details here...`}
                  defaultValue={selectedTemplates[modalType]?.content || ""}
                />
              </div>
            </div>
          ) : (
            /* STEP 2: THE IMPORT LIST */
            <div className="space-y-4">
              <button
                onClick={() => setImportView(false)}
                className="flex items-center gap-1 text-xs font-bold text-blue-600 hover:text-blue-800 mb-4"
              >
                <ChevronLeft size={14} /> Back to Editor
              </button>

              <div className="grid gap-3">
                {[
                  { id: "T1", name: "Modern Corporate", content: "..." },
                  { id: "T2", name: "Centered Minimal", content: "..." },
                  { id: "T3", name: "Information Dense", content: "..." },
                ].map((tpl) => (
                  <div
                    key={tpl.id}
                    className="flex items-center justify-between p-4 border rounded-xl hover:border-blue-400 hover:bg-blue-50 cursor-pointer transition-all group"
                    onClick={() => {
                      // Logic to "Import" this content into the editor
                      setSelectedTemplates((prev) => ({
                        ...prev,
                        [modalType]: tpl,
                      }));
                      setImportView(false);
                    }}
                  >
                    <div className="flex items-center gap-4">
                      <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center font-bold text-slate-400 text-xs">
                        {tpl.id}
                      </div>
                      <div>
                        <h4 className="text-sm font-bold text-slate-800">
                          {tpl.name}
                        </h4>
                        <p className="text-[10px] text-slate-500 truncate w-64">
                          {tpl.content}
                        </p>
                      </div>
                    </div>
                    <button className="px-3 py-1.5 bg-white border border-slate-200 text-blue-600 rounded-lg text-[10px] font-bold group-hover:bg-blue-600 group-hover:text-white transition-all">
                      IMPORT
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Footer actions */}
          <div className="pt-6 mt-6 border-t flex justify-end gap-3">
            <button
              onClick={() => setModalOpen(false)}
              className="px-4 py-2 text-xs font-bold text-slate-400"
            >
              Cancel
            </button>
            {!importView && (
              <button
                onClick={() => setModalOpen(false)}
                className="px-6 py-2 bg-blue-600 text-white rounded-xl text-xs font-bold shadow-lg shadow-blue-200 hover:bg-blue-700 transition-all"
              >
                Apply to Quotation
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ContractModal;
